export default __webpack_public_path__ + "static/media/A.b26ef2a1.mp3";